<template>
  <div>
    <div
      class="flex p-3 justify-between"
      :class="{ lock: role == 'free' && data.is_free == false }"
    >
      <div class="flex flex-row">
        <div class="flex items-center">
          <h3 class="text-sm font-medium text-black">
            {{ data.company_name }}
          </h3>
        </div>
      </div>
      <div class="flex gap-2 justify-left content-center items-center">
        <div
          class="content justify-center items-center content-center mx-auto cursor-pointer w-8 h-8 rounded-lg border border-indigo-500 p-1 bg-white text-base leading-6 shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
          @click="toggleFavoriteState(data)"
          :class="{ 'bg-indigo-500 ': data.isFavorite }"
        >
          <div class="group w-full flex items-center justify-center">
            <div>
              <Icon name="Heart" fill="#fff" stroke="#667eea" class="w-6" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="square" v-if="typeof data.product_image == 'string'">
        <img
          :src="data.product_image"
          alt=""
          class="advertisements__item__media"
        />
      </div>
      <div v-else class="square my-10">
        <div
          class="flex items-center bg-green-500 justify-center pb-0 mt-5 mb-20 px-4 sm:px-6 lg:px-8"
        ></div>
      </div>
    </div>
    <div class="flex justify-between items-center p-3">
      <div class="w-56 text-xs leading-4">
        <p>{{ data.company_desription }}</p>
      </div>
    </div>

    <div class="flex justify-between items-center px-3">
      <div class="flex flex-row gap-2">
        <a
          v-if="data.website && data.website.length"
          :href="data.website"
          target="_blank"
          class="cursor-pointer w-8 h-8 flex justify-center border rounded-full border-gray-400 p-1 hover:border-indigo-600 hover:bg-indigo-600 text-gray-500 hover:text-white duration-500"
        >
          <Icon
            name="Web"
            viewbox="0 0 24 24"
            class="w-4 fill-current"
            stroke="none"
          />
        </a>
        <a
          v-if="data.facebook_page_url && data.facebook_page_url.length"
          :href="data.facebook_page_url"
          target="_blank"
          class="cursor-pointer w-8 h-8 flex justify-center border rounded-full border-gray-400 p-1 hover:border-indigo-600 hover:bg-indigo-600 text-gray-500 hover:text-white duration-500"
        >
          <Icon
            name="Facebook"
            fill="rgb(160,174,196)"
            stroke="none"
            viewbox="0 0 10 19"
            class="w-2 fill-current"
          />
        </a>
        <a
          v-if="data.instagram_url && data.instagram_url.length"
          :href="data.instagram_url"
          target="_blank"
          class="cursor-pointer w-8 h-8 flex justify-center border rounded-full border-gray-400 p-1 hover:border-indigo-600 hover:bg-indigo-600 text-gray-500 hover:text-white duration-500"
        >
          <Icon
            name="Instagram"
            viewbox="0 0 15 15"
            class="w-4 fill-current"
            stroke="none"
          />
        </a>
        <a
          v-if="data.tiktok_account_url && data.tiktok_account_url.length"
          :href="data.tiktok_account_url"
          target="_blank"
          class="cursor-pointer w-8 h-8 flex justify-center border rounded-full border-gray-400 p-1 hover:border-indigo-600 hover:bg-indigo-600 text-gray-500 hover:text-white duration-500"
        >
          <Icon
            name="Tiktok"
            fill="rgb(160,174,196)"
            viewbox="0 0 32 32"
            class="w-4 fill-current"
            stroke="#cecece"
          />
        </a>
      </div>
      <a
        v-if="data.facebook_ad_library_link"
        :href="data.facebook_ad_library_link"
        target="_blank"
        class="text-xs font-semibold border border-indigo-600 rounded-lg p-2 hover:bg-gray-200 duration-500"
      >
        Ad library
      </a>
    </div>
    <div class="relative">
      <div class="square" v-if="role == 'free' && data.is_free == false">
        <div
          class="flex items-center justify-center pb-0 my-20 px-4 sm:px-6 lg:px-8"
        ></div>
      </div>
      <template v-if="role == 'free' && data.is_free == false">
        <UnlockTopBrands class="relative top-0 unlock" />
      </template>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Icon from "@/components/UI/Icon";
import UnlockTopBrands from "@/components/UnlockTopBrands";

export default {
  components: { Icon, UnlockTopBrands },
  props: {
    data: Object,
    isCollection: Boolean,
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();
    const user = computed(() => store.state.user);
    const role = computed(() => store.state.role);

    const toggleFavoriteState = async (ad) => {
      if (ad.isFavorite) {
        await store.dispatch("REMOVE_FAVORITE_BRAND", {
          user_id: user.value.id,
          brand: ad,
        });
      } else {
        await store.dispatch("ADD_FAVORITE_BRAND", {
          user_id: user.value.id,
          brand: ad,
        });
      }
    };

    const showPlans = () => {
      if (["free"].includes(role.value) && props.lock) {
            console.log("1")

        router.push("/pricing");
      }
    };

    return { toggleFavoriteState, role, showPlans };
  },
};
</script>

<style>
/* .post {
  filter: blur(8px);
} */
.text-606770 {
  color: #606770;
}
.lock {
  filter: blur(12px);
  pointer-events: none;
}
.square {
  width: 100%;
  background-color: black;
}
.clamp {
  max-height: calc(1rem * 7);
  display: -webkit-box;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.action {
  max-width: 100px;
  letter-spacing: normal;
  color: rgb(68, 73, 80);
  font-size: 12px;
  font-weight: bold;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, Arial, sans-serif;
  line-height: 26px;
  text-align: center;
  height: 30px;
  background-position: 0 0;
  border: 1px solid #667eea;
  border-radius: 10px;
  box-shadow: none;
  box-sizing: border-box;
  cursor: pointer;
  -webkit-font-smoothing: antialiased;
  font-weight: bold;
  padding: 0 11px;
  position: relative;
  text-shadow: none;
  transition: all 300ms cubic-bezier(0.1, 0.7, 0.1, 1), border-width 1ms;
  transition-property: background, border-color, border-width, color;
  vertical-align: middle;
}
</style>
